<template>
  <div>
    <b-modal
      id="Live1"
      title="ตารางรายละเอียดติดตั้งแต่ละจุด"
      size="lg"
      ok-only
      ok-title="ปิด"
    >
      <b-row>
        <!-- <b-col
          lg="12"
          md="12"
        >
          <h3>ตารางรายละเอียดติดตั้งแต่ละจุด</h3>
        </b-col> -->
        <b-col
          lg="8"
          md="8"
          class="d-flex align-items-center justify-content-end mb-1"
        />
        <b-col cols="12">
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(index)="data">
              {{ data.index +1 }}
            </template>
            <template #cell(camconnect)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(Total)="data">
              {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} คัน
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BBadge, BModal,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BModal,
    // BPagination,
    // BInputGroup,
    // BInputGroupAppend,
    // BFormInput,
    // BButton,
    // BFormGroup,
    // BFormSelect,
    // BCardBody,
    BBadge,
    // BDropdown,
    // BDropdownItem,
    // BDropdownDivider,
  },
  data() {
    return {
      fields: [
        {
          key: 'Phase',
          label: 'Phase',
          sortable: true,
        },
        {
          key: 'Camera_Desc',
          label: 'ตำแหน่งกล้อง',
        },
        {
          key: 'Total',
          label: 'ปริมาณจราจร',
          class: 'text-center',
        },
        {
          key: 'camconnect',
          label: 'สถานะ',
        },
        {
          key: 'Lastupdate',
          label: 'วันที่อัพเดตล่าสุด',
          sortable: true,
        },

      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        Online: 'Online', Offline: 'Offline',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getTableTraffic()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getTableTraffic()
    }, 300000)
  },
  methods: {
    getTableTraffic() {
      axios
        .post('/getTableTrafficDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
